import { ReactNode } from "react";

import { APP_MAX_WIDTH, Column, repeatElement, SkeletonRounded } from "@bridgesplit/ui";
import { matchPath, useLocation } from "react-router-dom";
import {
    EARN_SLUG,
    LEND_SLUG,
    LEND_VAULT_DETAIL_SLUG,
    LOOPS_SLUG,
    LOOP_DETAIL_SLUG,
    PORTFOLIO_OVERVIEW_SLUG
} from "app/constants";

import { PageBase } from "./Page";
import { DetailSkeleton, EarnSkeleton, LendSkeleton, LoopsSkeleton, PortfolioSkeleton } from "./RouteSkeletons";

export function AppFallback() {
    const { pathname } = useLocation();
    return <PageBase hideFooter>{selectRouteSkeleton(pathname)}</PageBase>;
}

function selectRouteSkeleton(pathname: string): ReactNode {
    const isDetail =
        matchPath(`${LEND_VAULT_DETAIL_SLUG}/:vaultIdentifier`, pathname) ||
        matchPath(`${EARN_SLUG}/:vaultIdentifier`, pathname) ||
        matchPath(`${LOOP_DETAIL_SLUG}/:address`, pathname);
    if (isDetail) return <DetailSkeleton />;

    if (pathname === LEND_SLUG || pathname === "/") return <LendSkeleton />;
    if (pathname === EARN_SLUG) return <EarnSkeleton />;
    if (pathname === LOOPS_SLUG) return <LoopsSkeleton />;
    if (pathname === PORTFOLIO_OVERVIEW_SLUG) return <PortfolioSkeleton />;

    return <AppFallbackContent />;
}

export function AppFallbackContent() {
    return (
        <Column spacing={4} sx={{ maxWidth: APP_MAX_WIDTH, width: "100%" }}>
            <SkeletonRounded sx={{ width: "240px", height: "40px" }} />
            <Column spacing={2}>{repeatElement(<SkeletonRounded sx={{ width: "100%", height: "120px" }} />, 4)}</Column>
        </Column>
    );
}
